export function createSingleFlightRefresh<T>(doRefresh: () => Promise<T>): () => Promise<T> {
  let pending: Promise<T> | null = null;
  return () => {
    pending ??= doRefresh().finally(() => {
      pending = null;
    });
    return pending;
  };
}
